import Navbar from './sections/navbar/Navbar';
import Header from './sections/header/Header';
import Portfolio from './sections/portfolio/Portfolio';
import About from './sections/about/About';
import Contact from './sections/contact/Contact';
import Footer from './sections/footer/Footer';
import FloatingNav from './sections/floating-nav/FloatingNav';

const App = () => {
  return (
<main>
  <Navbar/>
  <Header/>
  <About/>
  <Portfolio/>
  <Contact/>
  <Footer/>
  <FloatingNav/>
</main>
  )
}

export default App